import { IActionContext } from '@msdyn365-commerce/core';
import { IProductRefinerHierarchy } from '@msdyn365-commerce/commerce-entities';
import getHandlers from './predefined-refiners/index';

export interface IPredefinedRefinerHandler {
    apply: (refiner: IProductRefinerHierarchy) => void;
    isMatch: (refiner: IProductRefinerHierarchy) => boolean;
}

export function applyPredefinedRefiners(context: IActionContext, refinerHierarchy: IProductRefinerHierarchy[] | undefined): void {
    if (!refinerHierarchy || refinerHierarchy.length === 0) {
        return;
    }

    getHandlers(context).forEach(handler => {
        refinerHierarchy.forEach(refiner => {
            if (handler.isMatch(refiner)) {
                handler.apply(refiner);
            }
        });
    });
}
